<template>
  <div @click="openPopup">
    <span>
      <slot></slot>
    </span>

    <popup title="Change currency" class="currency-modal" ref="currencyPopup">
      <template #before-content>
        <div class="modal-description">{{ trans("modals.currency_modal.description") }}</div>
      </template>
    </popup>
  </div>
</template>

<script setup lang="ts">
  import { markRaw, reactive, ref } from "vue";
  import Popup from "@/components/_partials/Popup.vue";
  import { LotCurrencyList } from "@/components/_partials/lot-info-popup";
  import { trans } from "@/utils/trans";

  const state = reactive({
    component: markRaw(LotCurrencyList)
  });

  const currencyPopup = ref<Popup>(null);

  const openPopup = () => {
    currencyPopup.value?.toggleComponent(state.component);
    currencyPopup.value?.open();
  };
</script>
